import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { CameraFeaturesTable, deviceCamTierObj, getCameraTierName } from './';

export default function EnhancedCamModal2({ user, currentDevice, userActions }) {
  const history = useHistory();
  const tierObj = deviceCamTierObj(user, currentDevice.macAddress);
  const currentTier = getCameraTierName(tierObj.tier);

  const handleTierClick = (tier) => {
    // Close modal
    userActions.doModal(null);

    // Determine if current subscription is annual or default to annual
    const isCurrentAnnual = tierObj.tier === 2 || tierObj.tier === 4; // 2 = Silver Annual, 4 = Gold Annual
    const period = isCurrentAnnual ? 'yearly' : 'monthly';

    // Map tier name to product name
    const productName = tier === 'silver'
      ? `awn-camera-tier1-${period}`
      : tier === 'gold'
        ? `awn-camera-tier2-${period}`
        : null;

    if (productName) {
      // Navigate to checkout with deviceId
      history.push(`/subscriptions/checkout?subscription=${productName}&deviceId=${currentDevice._id}`);
    }
  };

  return (
    <div className='payment-enhanced-cam-modal2'>
      <CameraFeaturesTable
        onClick={handleTierClick}
        currentTier={currentTier}
      />
    </div>
  );
}

EnhancedCamModal2.propTypes = {
  user: PropTypes.object.isRequired,
  currentDevice: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired
};

EnhancedCamModal2.displayName = 'EnhancedCamModal2';
